import { useCallback, useState } from 'react';
import { AgentAllocation } from '../../../../models/AgentsAllocation';
import { RoutingProfile } from '../../../../models/RoutingProfiles';
import { GridSelectionModel } from '@mui/x-data-grid/models/gridSelectionModel';
import { fetchAgentsAllocation } from '../../../../services/activeAgents';
import { fetchRoutingProfiles } from '../../../../services/routingProfiles';

export const useAgentsDashboardPage = () => {
  const [agents, setAgents] = useState<AgentAllocation[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedAgentIds, setSelectedAgentIds] = useState<GridSelectionModel>([]);
  const [allRoutingProfiles, setAllRoutingProfiles] = useState<RoutingProfile[]>([]);

  const fetchData = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);

      const agentsResponse = await fetchAgentsAllocation();
      const routingProfilesResponse = await fetchRoutingProfiles();

      setAgents(agentsResponse.agentAllocation);
      setAllRoutingProfiles(routingProfilesResponse.routingProfiles);
    } catch (error) {
      throw new Error(`Failed to load data: ${(error as Error).message}`);
    } finally {
      setLoading(false);
    }
  }, []);

  const refetchAgents = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);

      const agentsResponse = await fetchAgentsAllocation();

      setAgents(agentsResponse.agentAllocation);
    } catch (error) {
      throw new Error(`Failed to load data: ${(error as Error).message}`);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    agents,
    setAgents,
    loading,
    setLoading,
    selectedAgentIds,
    setSelectedAgentIds,
    allRoutingProfiles,
    setAllRoutingProfiles,
    fetchData,
    refetchAgents
  };
};
